import type { AppContext } from '../../game/context.js';
import { webBannerDue, webToAppDue } from '../../services/prompts.js';
import type { FeatureManifest } from '../registry.js';

/** The Play banner is due: Android web, its own cadence, once a session. E2e builds keep it off unless the URL has `?banner=1`, so it does not cover the HUD in every phone spec. */
export function bannerDue(a: AppContext): boolean {
  if (a.session.checked.has('webToAppBanner')) return false;
  if (a.flags.e2e && !new URLSearchParams(location.search).has('banner')) return false;
  return webBannerDue(a.services.store.state, a.device, navigator.userAgent, a.services.now());
}

/**
 * Flow G web → app (OVL-05): mobile web after level 10, again after 3 days, at most 3 times. On
 * Android web the same flow also puts a slim "Get Market Pop on Google Play" strip on the map
 * (index.tsx), on its own count and never within the modal's gap.
 */
export default {
  id: 'webToApp',
  online: true,
  provides: ['webToApp'],
  mapOrder: 40,
  mapDue: (a) => webToAppDue(a.services.store.state, a.device, a.services.now()) || bannerDue(a),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
